// extracted by mini-css-extract-plugin
export var radioInputRow = "F_vf";
export var radioInputColumn = "F_vg";
export var inputOptionRow = "F_qM";
export var inputOptionColumn = "F_qN";